<app-bookupp-header *ngIf="merchant?.bookuppEnabled"></app-bookupp-header>
<app-header *ngIf="!merchant?.bookuppEnabled"></app-header>

<section class="my-5" *ngIf="globalService.whitelabelBannerUrl">
    <div class="container aos-init aos-animate text-center" data-aos="fade-up">
        <img class="img-fluid" src="{{ globalService.whitelabelBannerUrl }}" width="100%" />
    </div>
</section>

<section class="my-3">
    <div class="aos-init aos-animate" data-aos="fade-up" [ngClass]="wrapperClass">
        <div class="row" *ngIf="globalService.subdomain != 'redefine'">
            <h1 class="mb-4">{{ globalService.whitelabelHeading }}</h1>
        </div>

        <div class="row" *ngIf="parkings">
            <div *ngFor="let parking of parkings" class="col-md-3">
                <app-parking-list-item [forMerchants]="false" [parking]="parking" (onSelect)="onSelect($event)"></app-parking-list-item>
            </div>
        </div>
    </div>
</section>

<app-bookupp-footer *ngIf="merchant?.bookuppEnabled"></app-bookupp-footer>
<app-footer *ngIf="!merchant?.bookuppEnabled"></app-footer>
